import { useMemo } from 'react';
import { ApolloError, QueryResult } from '@apollo/client';
import { DateTime } from 'luxon';
import {
  Period,
  PeriodsDocument,
  PeriodsQuery,
  PeriodsQueryVariables,
  SortOrder
} from 'graphql/types';
import usePersistedCacheQuery from 'modules/common/hooks/usePersistedCacheQuery';

export const useGetTimesheetPeriods = (
  fromDate: DateTime,
  toDate: DateTime
): {
  loading: boolean;
  error: ApolloError | undefined;
  periods: Period[] | undefined;
  fetchMore: QueryResult<PeriodsQuery, PeriodsQueryVariables>['fetchMore'];
} => {
  const { loading, data, error, fetchMore } = usePersistedCacheQuery<
    PeriodsQuery,
    PeriodsQueryVariables
  >(PeriodsDocument, {
    variables: {
      input: {
        filter: {
          fromDate: fromDate.toISODate(),
          toDate: toDate.toISODate()
        },
        count: Math.ceil(toDate.diff(fromDate, 'days').days),
        sort: SortOrder.Ascending
      }
    }
  });

  return useMemo(() => {
    return {
      loading,
      error,
      periods: data?.periods?.items,
      fetchMore
    };
  }, [data?.periods?.items, error, fetchMore, loading]);
};
